var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "trash-icon_svg__Layer_2",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21.17"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".trash-icon_svg__cls-2{stroke-width:0;fill:#476550}"))), /*#__PURE__*/React.createElement("g", {
    id: "trash-icon_svg__Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .58h20v20H0z",
    style: {
      strokeWidth: 0,
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 21.17H7.33c-1.12 0-2.18-.42-2.99-1.19A4.292 4.292 0 0 1 3 17.05l-.67-13.5c-.03-.55.4-1.02.95-1.05.55-.03 1.02.4 1.05.95L5 16.95c.03.6.29 1.16.72 1.58.44.41 1 .64 1.6.64h5.33c.6 0 1.17-.23 1.61-.64s.69-.97.72-1.57l.67-13.5c.03-.55.51-.98 1.05-.95.55.03.98.5.95 1.05l-.67 13.5a4.312 4.312 0 0 1-1.34 2.92c-.81.77-1.87 1.19-2.98 1.19Z",
    className: "trash-icon_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.33 4.5H1.66c-.55 0-1-.45-1-1s.45-1 1-1h16.67c.55 0 1 .45 1 1s-.45 1-1 1ZM8.12 17c-.53 0-.97-.42-1-.96L6.7 6.87a.996.996 0 1 1 1.99-.09l.42 9.17c.02.55-.4 1.02-.95 1.04h-.05ZM11.88 17h-.05a.995.995 0 0 1-.95-1.04l.42-9.17c.03-.55.51-.97 1.04-.95.55.03.98.49.95 1.04l-.42 9.17c-.02.54-.47.95-1 .95Z",
    className: "trash-icon_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 4.5c-.42 0-.81-.26-.95-.68l-.46-1.36a.678.678 0 0 0-.24-.33.7.7 0 0 0-.39-.13H8.7c-.14 0-.27.04-.39.13-.11.08-.2.2-.24.33l-.45 1.36c-.17.52-.74.81-1.27.63a.999.999 0 0 1-.63-1.27l.45-1.36c.18-.53.51-.99.97-1.32.45-.33.99-.5 1.56-.51h2.6c.57 0 1.1.18 1.56.51.46.33.79.79.97 1.32l.46 1.35a.999.999 0 0 1-.95 1.32Z",
    className: "trash-icon_svg__cls-2"
  }))));
};
export default SvgTrashIcon;